import type { CSSProperties } from 'react';

const EXCEL_COLUMN_WIDTH_TO_PX = 7;
const EXCEL_COLUMN_WIDTH_PADDING_PX = 5;
const EXCEL_ROW_HEIGHT_TO_PX = 4 / 3;

export const DEFAULT_XLSX_COLUMN_WIDTH_PX = 64;
export const DEFAULT_XLSX_PREVIEW_COLUMN_WIDTH_PX = 175;
export const DEFAULT_XLSX_ROW_HEIGHT_PX = 28;
export const INTERNAL_REFERENCE_XLSX_ROW_HEIGHT_PX = 50;
export const ROW_REFERENCE_XLSX_ROW_HEIGHT_PX = 30;
export const MIN_XLSX_COLUMN_WIDTH_PX = 18;
export const MIN_XLSX_ROW_HEIGHT_PX = DEFAULT_XLSX_ROW_HEIGHT_PX;

export const getFixedXlsxRowHeightStyle = (height: number): CSSProperties => ({
  height,
  maxHeight: height,
  minHeight: height,
});

export const INTERNAL_REFERENCE_XLSX_ROW_HEIGHT_STYLE = getFixedXlsxRowHeightStyle(
  INTERNAL_REFERENCE_XLSX_ROW_HEIGHT_PX
);
export const ROW_REFERENCE_XLSX_ROW_HEIGHT_STYLE = getFixedXlsxRowHeightStyle(ROW_REFERENCE_XLSX_ROW_HEIGHT_PX);

export const getXlsxColumnWidthPx = (columnWidth?: number | null): number | undefined => {
  if (typeof columnWidth !== 'number' || !Number.isFinite(columnWidth)) {
    return undefined;
  }

  if (columnWidth === 0) {
    return 0;
  }

  return Math.max(
    MIN_XLSX_COLUMN_WIDTH_PX,
    Math.round(columnWidth * EXCEL_COLUMN_WIDTH_TO_PX + EXCEL_COLUMN_WIDTH_PADDING_PX)
  );
};

export const getXlsxRowHeightPx = (rowHeight?: number | null): number | undefined => {
  if (typeof rowHeight !== 'number' || !Number.isFinite(rowHeight) || rowHeight <= 0) {
    return undefined;
  }

  return Math.max(MIN_XLSX_ROW_HEIGHT_PX, Math.round(rowHeight * EXCEL_ROW_HEIGHT_TO_PX));
};

export const getXlsxRowHeightStyle = (rowHeight?: number | null): CSSProperties => {
  const height = getXlsxRowHeightPx(rowHeight);

  return height ? { height, minHeight: height } : {};
};
